import React from "react";

import stylesgfi from "./NationalSchoolGames.module.css";
import Breadcrumb from "../../components/common/Breadcrumb";
// import Button from "react-bootstrap/Button";
import { Button, Container, Row, Col } from "react-bootstrap";
import useBWKLSchedule from "./hooks/useBWKLSchedule";

// import Athlite from "./Athlite";

export default function BiharWomenKabaddiLeagueE2() {
  const [link] = useBWKLSchedule({
    endpoint:
      "https://bssa-json-server-vercel-deployment.vercel.app/bwkl-e2-link",
  });
  return (
    <>
      <Breadcrumb
        pageName={BiharWomenKabaddiLeagueE2}
        pageTitle={"BiharWomenKabaddiLeagueE2"}
        img_url={"/img/BWKLE2-Desktop.jpeg"}
        mobile_banner="/img/BWKLE2-Mobile.jpeg"
      />
      <div></div>
      <div>
        <h1 className={`${stylesgfi.title}`}>
          द्वितीय बिहार महिला कबड्डी लीग 2026
        </h1>
      </div>

      {/* <Container className="button-container mt-5">
        <div className="mt-5" style={{ marginTop: "40px" }}>
          <Row>
            <Col
              xs={12}
              md={3}
              className="text-center "
              style={{ marginTop: "20px" }}
            >
              <Button
                className="animated-button"
                variant="success"
                href="/matchfixture"
                // disabled
              >
                मैच शेड्यूल ↗
              </Button>
            </Col>
            <Col
              xs={12}
              md={3}
              className="text-center "
              style={{ marginTop: "20px" }}
            >
              <Button
                className="animated-button"
                variant="success"
                href="/bihar-Women-Kabaddi-Match-Result-Edition-2"
                target="_blank"
                // disabled
              >
                परिणाम ↗
              </Button>
            </Col>
            <Col
              xs={12}
              md={3}
              className="text-center "
              style={{ marginTop: "20px" }}
            >
              <Button
                className="animated-button"
                variant="success"
                href="https://www.elev8sportz.com/bihar-women-kabaddi-league/schedule"
                target="_blank"
                disabled
              >
                लेटेस्ट परिणाम ↗
              </Button>
            </Col>

            <Col
              xs={12}
              md={3}
              className="text-center"
              style={{ marginTop: "20px" }}
            >
              <Button
                className="animated-button"
                variant="success"
                // href="https://www.youtube.com/live/rMLo-Q4Loh8"
                // href="https://www.youtube.com/watch?v=kZjncxfox9s"
                //href="https://www.youtube.com/watch?v=ydF07OqSsNU"
                // href="https://www.youtube.com/watch?v=fz3-K7K5VYU"
                // href="https://www.youtube.com/watch?v=YTUTzj1cOV0"
                // href="https://www.youtube.com/watch?v=Gda8hY8oXJk"
                href="https://www.youtube.com/watch?v=XGCx6cxUg_I"
                target="_blank"
                disabled
              >
                मैच का सीधा प्रसारण ↗
              </Button>
            </Col>
            <Col
              xs={12}
              md={3}
              className="text-center"
              style={{ marginTop: "20px" }}
            >
              <Button
                className="animated-button"
                variant="success"
                href="https://linktr.ee/univsports"
                target="_blank"
                disabled
              >
                विस्तृत जानकारी के लिए क्लिक करें ↗
              </Button>
            </Col>
          </Row>
        </div>
      </Container> */}

      <Container className="button-container">
        <div className="row text-center">
          {" "}
          {/* Bootstrap 3 rows use .row and columns use .col-*-* */}
          {[
            {
              label: "मैच शेड्यूल ↗",
              href: "/matchfixture",
            },
            {
              label: "परिणाम ↗",
              href: "/bihar-Women-Kabaddi-Match-Result-Edition-2",
            },
            {
              label: "अंक तालिका ↗",
              href: "/bihar-Women-Kabaddi-Points-Edition-2",
            },
            // { label: "लेटेस्ट परिणाम ↗", href: "...", disabled: true },
            {
              label: "मैच का सीधा प्रसारण ↗",
              href:
                (link || [])[0] ||
                "https://www.youtube.com/live/4Pte7DabJKQ?si=NNtJcpDQfchc9URG",
              disabled: false,
            },
            {
              label: "विस्तृत जानकारी के लिए क्लिक करें ↗",
              href: "...",
              disabled: true,
            },
          ].map((btn, idx) => (
            <div
              key={idx}
              // className="col-xs-12 col-sm-6 col-md-3"
              className="col-xs-12 col-sm-6 col-md-4"
              style={{ marginBottom: "20px" }}
            >
              <Button
                variant="success"
                className="animated-button"
                style={{ width: "100%", padding: "15px 10px" }} // Width 100% mimics d-grid
                href={btn.href}
                disabled={btn.disabled}
              >
                {btn.label}
              </Button>
            </div>
          ))}
        </div>
      </Container>

      {/* <div className={`container ${stylesgfi.game_sgfi}`}> */}
      <div className={`container`} style={{ marginBottom: "40px" }}>
        <Row>
          {[
            { src: "/img/BWKLE2/sitamarhi.png", alt: "सीतामढ़ी सेंटीनेल्स" },
            { src: "/img/BWKLE2/magadh.png", alt: "मगध वरियर्स" },
            { src: "/img/BWKLE2/saran.png", alt: "सारण स्ट्राइकर्स" },
            { src: "/img/BWKLE2/patna.png", alt: "पटना पेलिकन" },
            { src: "/img/BWKLE2/nalanda.png", alt: "नालंदा निंजास" },
            { src: "/img/BWKLE2/siwan.png", alt: "सीवान टाइटेंस" },
          ].map((team) => (
            <Col
              key={team.alt}
              xs={6}
              md={4}
              className="text-center"
              style={{ marginBottom: "16px" }}
            >
              <a>
                <div
                  className={`${stylesgfi.game_card}`}
                  style={{ boxShadow: "none" }}
                >
                  <img
                    src={team.src}
                    alt={team.alt}
                    style={{ height: "160px", width: "auto", padding: "2px" }}
                  />
                </div>
              </a>
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
}
